/// <reference types="bootstrap"/>
import BootstrapScrollSpy from 'bootstrap/js/dist/scrollspy';
class ScrollSpy {
    constructor(config) {
        this.config = config;
        this.run();
    }
    run() {
        this.instance = this.createInstance(this.config.element);
    }
    createInstance(triggerEl) {
        return new BootstrapScrollSpy(document.body, { target: '.navbar-nav' });
    }
    getInstance() {
        return this.instance;
    }
}
export { ScrollSpy };
